// extracted by mini-css-extract-plugin
export var notificationHost = "_ic-0";